/* eslint-disable jsx-a11y/alt-text */
/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { PureComponent, Fragment } from 'react';
import { shopContext } from '../../contexts/aniplus';
import { withRouter } from 'react-router-dom';
import axios from 'axios';

import StoreLeftMenu from '../../menu/StoreLeftMenu';
import Footer from '../../components/Footer';

import { toast } from 'react-toastify'; //토스트(toast)
// import { confirmAlert } from "react-confirm-alert"; //알럿창(alert confirm)

//import $ from 'jquery';
//import '../../slick.js'
import Slider from 'react-slick';

import OriginalComment from './OriginalComment';
//import OriginalGoodsEtcList from './OriginalGoodsEtcList'
// import $ from "jquery";

class StoreLottery extends PureComponent {
  state = {
    slideIndex: 0,
    slidePlay: true,
    ichSerial: 0,
    toggle: false,
  };
  _isLoad = false;
  componentDidMount = () => {
    this._isLoad = true;

    this._getData(1);
    setTimeout(() => {
      this._onGoto(0);
    }, 2000);
  };
  componentWillUnmount = () => {
    this._isLoad = false;
  };
  _getData = async (gotoPage) => {
    // const { pageSize } = this.state;
    // const { match, location } = this.props;
    const result = await this._getApi(1, 100);
    const intReturn = result.data[0].intReturn;
    const con = result.data[0].con;
    const pageCount = result.data[0].pageCount;
    const originalList = result.data[0].listData;

    if (intReturn === 0) {
      if (con > 0) {
        if (this._isLoad) {
          this.setState({
            originalList: originalList,
            gotoPage: gotoPage,
            con: con,
            pageCount: pageCount,
            ichSerial: originalList[0].ichSerial,
            img: originalList[0].img,
          });
        }
        //console.log(originalList[0].ichSerial)
        //this._getTop(originalList[0].ichSerial)
      }
    }
  };

  _getApi = (gotoPage, pageSize) => {
    const { apiUrl } = this.props;

    return axios(
      apiUrl + '/lotteryList?gotoPage=' + gotoPage + '&pageSize=' + pageSize
    )
      .then((response) => response)
      .catch((error) => {
        alert(
          '네트워크 오류: 오리지널 굿즈 데이터를 로드 하는 중 오류가 발생했습니다.'
        );
      });
  };

  _renderItem = () => {
    const { originalList } = this.state;

    const list = originalList.map((item, index) => {
      return (
        <div
          className="store_orgin_item"
          key={index}
          onClick={() => this._onGoto(index)}
        >
          {/* 오리지널 굿즈 */}
          <div className="orgin_goods">
            {item.saleActive ? <div className="ico_new">new</div> : null}
            <div className="thumb star">
              <img src={item.listImg} alt="" />
            </div>
            <div className="subject">
              <a
                style={{ cursor: 'pointer' }}
                onClick={() => this._onGoto(index)}
              >
                {item.title}
              </a>
            </div>
          </div>
        </div>
      );
    });

    return list;
  };
  _online = (goodSerial, SaleActive) => {
    if (SaleActive) {
      window.open('https://shop.aniplustv.com/Item/' + goodSerial, '', '');
    } else {
      toast.warn('오프라인에서만 구매가 가능한 굿즈입니다.');
    }
  };
  _renderGoodItem = () => {
    const { goodList } = this.state;
    const con = goodList.length;
    const list = goodList.map((item, index) => {
      return (
        <div
          key={index}
          className="img_orgin_item"
          style={{ width: index === con ? '100%' : null }}
          index={index}
          con={con}
          onClick={() => this._online(item.goodSerial, item.SaleActive)}
        >
          <div className="inven_status">
            <dl>
              <dt>서울</dt>
              <dd>
                <span
                  className={
                    item.h_stock <= 0
                      ? 'soldout'
                      : item.h_stock >= 10
                      ? 'full'
                      : 'soon'
                  }
                >
                  {item.h_stock <= 0
                    ? '상품품절'
                    : item.h_stock >= 10
                    ? '재고충분'
                    : '매진임박'}
                </span>
              </dd>
            </dl>
            <dl>
              <dt>대전</dt>
              <dd>
                <span
                  className={
                    item.d_stock <= 0
                      ? 'soldout'
                      : item.h_stock >= 10
                      ? 'full'
                      : 'soon'
                  }
                >
                  {item.d_stock <= 0
                    ? '상품품절'
                    : item.h_stock >= 10
                    ? '재고충분'
                    : '매진임박'}
                </span>
              </dd>
            </dl>
            <dl>
              <dt>광주</dt>
              <dd>
                <span
                  className={
                    item.g_stock <= 0
                      ? 'soldout'
                      : item.h_stock >= 10
                      ? 'full'
                      : 'soon'
                  }
                >
                  {item.g_stock <= 0
                    ? '상품품절'
                    : item.h_stock >= 10
                    ? '재고충분'
                    : '매진임박'}
                </span>
              </dd>
            </dl>
            <dl>
              <dt>부산</dt>
              <dd>
                <span
                  className={
                    item.b_stock <= 0
                      ? 'soldout'
                      : item.h_stock >= 10
                      ? 'full'
                      : 'soon'
                  }
                >
                  {item.b_stock <= 0
                    ? '상품품절'
                    : item.h_stock >= 10
                    ? '재고충분'
                    : '매진임박'}
                </span>
              </dd>
            </dl>
          </div>
          <img src={item.good_Img} />{' '}
          {/* 실제 서비스시 originalImg 등록 후 변경할 것 */}
        </div>
      );
    });
    return list;
  };
  _afterChange = (index, idx) => {};
  _beforChange = (current, next) => {
    const { originalList } = this.state;
    //const { originalList } = this.state
    //console.log('aaaa ==> ' + current)
    //if(current > 0) {
    //    console.log(bannerList[current].idx)
    //}
    if (originalList) {
      const ichSerial = originalList[next].ichSerial;
      const img = originalList[next].img;
      if (this._isLoad) {
        this.setState({
          slideIndex: next,
          ichSerial,
          img,
        });
      }
    } else {
      if (this._isLoad) {
        this.setState({
          slideIndex: next,
        });
      }
    }
  };
  _onNext = () => {
    this.slider.slickNext();
  };
  _onPrev = () => {
    this.slider.slickPrev();
  };
  _onGoto = (i) => {
    const { originalList } = this.state;
    ////console.log(i)
    //console.log(i)
    const ichSerial = originalList[i].ichSerial;
    const img = originalList[i].img;
    //console.log(ichSerial)

    if (this._isLoad) {
      this.slider.slickGoTo(i);
      this.setState({
        ichSerial,
        img,
      });
    }
    //this._getTop(ichSerial)
  };
  _back = () => {
    const { history } = this.props;

    history.goBack();
  };
  _toggle = () => {
    const { toggle } = this.state;
    if (this._isLoad) {
      this.setState({
        toggle: !toggle,
      });
    }
  };
  render() {
    const {
      originalList,

      ichSerial,
      img,
      toggle,
    } = this.state;
    const { imgUrl } = this.props;
    var settings = {
      dots: false,
      //dotsClass: "slick-dots slick-thumb",
      infinite: true,
      //speed: 500,
      slidesToShow: 12,
      slidesToScroll: 1,
      arrows: false,
      autoplay: false,
      //speed: 3000,
      className: 'store_orgin_list',
      pauseOnFocus: true,
      //fade: true,
      adaptiveHeight: false,
      centerMode: false,

      //variableWidth: true,
      beforeChange: (current, next) => this._beforChange(current, next),
      afterChange: (index) => this._afterChange(index),
    };
    return (
      <Fragment>
        <div className="content">
          <StoreLeftMenu />

          {/* 오른쪽 콘텐츠 */}
          <div className="vod_list_right store_right">
            <div className="vod_list_group">
              <div className="store_wrap">
                {/* 스토어 스토리 */}
                <div className="store_blog orgin">
                  {/* 스토리 상단 */}
                  <div className="blog_top">
                    <h2 className="tit">
                      <button
                        type="button"
                        className="btn_prev"
                        onClick={this._back}
                      >
                        <img
                          src={imgUrl + '/img/store/arrw_pre.svg'}
                          alt="이전"
                        />
                      </button>
                      제일복권
                    </h2>
                  </div>
                  {/* 스토리 본문 */}
                  <div className="blog_container">
                    {/* 오리지널 굿즈 */}
                    <div className="store_orgin">
                      {/* 오리지널 굿즈 상단 */}
                      {/*
                                            <div className="store_orgin_top">
                                                <h3><span className="tag">오리지널 굿즈</span> <strong className="num">총 {con}개</strong></h3>
                                                <ul className="store_orgin_rt">
                                                    <li>
                                                        오직 애니플러스에서만 만날 수 있는 애니플러스 오리지널 굿즈<em>!</em><br/>
                                                        국내 최대 규모, 최고의 퀄리티, 애니플러스만이 가능한 노하우로 고객님이 만족하시는 최고의 굿즈를 만듭니다.
                                                    </li>
                                                    <li>
                                                        <img src="/img/store/aniplus_orgin.png" alt="ANIPLUS ORIGINAL GOODS"/>
                                                    </li>
                                                </ul>
                                            </div>
                                            */}
                      {/* 오리지널 굿즈 컨테이너 */}
                      <div
                        className="store_orgin_container"
                        onMouseEnter={this._toggle}
                        onMouseLeave={this._toggle}
                      >
                        {/* 슬라이드 이전/다음 */}
                        {toggle ? (
                          <>
                            <button
                              type="button"
                              className="orgin_arrw prev"
                              onClick={this._onPrev}
                            >
                              <img
                                src={imgUrl + '/img/store/arrw_slide_prev.svg'}
                                alt="이전"
                              />
                            </button>
                            <button
                              type="button"
                              className="orgin_arrw next"
                              onClick={this._onNext}
                            >
                              <img
                                src={imgUrl + '/img/store/arrw_slide_next.svg'}
                                alt="다음"
                              />
                            </button>
                          </>
                        ) : null}

                        {/* 오리지널 굿즈 리스트 */}
                        {/*<div className="store_orgin_list">*/}
                        <Slider
                          ref={(ref) => (this.slider = ref)}
                          {...settings}
                        >
                          {originalList ? this._renderItem() : null}
                        </Slider>
                        {/*</div>*/}
                      </div>
                    </div>
                    {/* 내용 */}
                    <div className="blog_content">
                      <div className="img_orgin">
                        <div className="img_orgin_visual">
                          <img src={originalList ? img : null} />
                          {/*실제 서비스시 image2에 등록후에 변경 할 것 */}
                        </div>

                        <div className="img_orgin_list"></div>
                      </div>
                    </div>
                  </div>

                  {/* 댓글 */}
                  {ichSerial !== 0 ? <OriginalComment idx={ichSerial} /> : null}
                </div>

                {/* 오리지널 굿즈 온라인 판매 */}
                {/* ichSerial !== 0 ? (
                                    <OriginalGoodsEtcList 
                                        idx={ichSerial}
                                    />
                                ) : null */}
              </div>
            </div>
            <Footer />
          </div>
          {/* /220109 store */}
          <div className="clear"></div>
        </div>
      </Fragment>
    );
  }
}

export default shopContext(withRouter(React.memo(StoreLottery)));
